<template>
  <section>
    <h3
      v-if="calculating"
      style="margin: 3rem auto; width: 280px; font-size: 3rem; font-weight: 600;"
    >
      網頁導向中...
    </h3>
    <div v-else style="margin: 15% auto; width: 980px;">
      <div style="font-size: 3rem; font-weight: 600; text-align: center;">
        <a @click="redirectToAdmin2">重新導向</a>
      </div>
    </div>
    <b-loading :active="calculating" :is-full-page="true" :can-cancel="false" />
  </section>
</template>
<script>
import notifyService from '@/services/notifyService'
import { EMPLOYEES_API } from '@/utils/apis'
export default {
  name: 'CruiseInquiries',
  data() {
    return {
      calculating: false,
      resultData: null,
      url: ''
    }
  },
  mounted() {
    this.redirectToAdmin2()
  },
  methods: {
    async redirectToAdmin2() {
      try {
        this.calculating = true

        const api = `${EMPLOYEES_API}/token`
        const res = await this.axios.post(api)
        this.resultData = res.data.data

        this.url = `${this.resultData.host}/fantasy?id=${this.resultData.id}&token=${this.resultData.token}&page=cruise-inquiries`

        window.open(this.url)
      } catch (e) {
        this.resultData = null

        notifyService.fetch_error('jwt_token', e)
      } finally {
        this.calculating = false
      }
    }
  }
}
</script>
